import { useEffect, useMemo, useRef } from "react";
import { formatFullDate } from "../../utils/formatDate";
import { BrandLockup } from "./BrandLockup";
import { LogotipoBlanco } from "../../assets/identity/LogotipoBlanco";
import { CityInfoTicker } from "./CityInfoTicker";
import { HeaderAdTicker } from "./HeaderAdTicker";
import { InstallAppButton } from "./InstallAppButton";

export const PodcastHeader = () => {
  const today = useMemo(() => formatFullDate(), []);
  const headerRef = useRef(null);

  useEffect(() => {
    if (!headerRef.current) return;

    const observer = new ResizeObserver(([entry]) => {
      const height = entry.target.getBoundingClientRect().height;
      document.documentElement.style.setProperty("--podcast-header-h", `${height}px`);
    });
    observer.observe(headerRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <header
      ref={headerRef}
      className="w-full px-0 fixed top-0 left-0 right-0 z-[70]"
      style={{
        background: "linear-gradient(105deg,#e0217a 0%,#a01a72 55%,#5c1a6b 100%)",
        borderBottom: "1px solid rgba(255,255,255,.12)",
        // Instalada en iOS la app ocupa toda la pantalla: sin esto el logotipo
        // quedaría debajo de la hora y la batería.
        paddingTop: "env(safe-area-inset-top)",
      }}
    >
      <div className="px-5 sm:px-6 pt-2 flex items-center justify-between gap-2">
        <LogotipoBlanco className="h-4 w-auto shrink-0" />
        <div className="flex items-center gap-2 min-w-0">
          <InstallAppButton />
          <span className="text-white/85 text-[11px] sm:text-xs font-medium text-right shrink-0">
            {today}
          </span>
        </div>
      </div>

      <div className="mt-3 bg-white/95 px-5 sm:px-6 py-2">
        <p className="text-[9px] font-semibold tracking-[1.5px] text-black/45 uppercase">
          Una colaboración de
        </p>
        <BrandLockup size="md" className="mt-1.5" />
      </div>

      <div className="px-0 pt-2 pb-1.5">
        <CityInfoTicker />
      </div>

      <div className="px-0 pb-0.5">
        <HeaderAdTicker />
      </div>
    </header>
  );
};
